import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useIntl } from 'react-intl'
import { messages } from '../../messages'

type DeleteWaypointDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: (legToRemove: 'before' | 'after') => void
  waypointNumber: number
  legBeforeNumber: number
  legAfterNumber: number
}

const DeleteWaypointDialog = ({
  open,
  onClose,
  onConfirm,
  legBeforeNumber,
  legAfterNumber,
}: DeleteWaypointDialogProps) => {
  const { formatMessage } = useIntl()

  const handleRemoveBefore = () => {
    onConfirm('before')
    onClose()
  }

  const handleRemoveAfter = () => {
    onConfirm('after')
    onClose()
  }

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      aria-labelledby="delete-waypoint-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="delete-waypoint-dialog-title" sx={{ textAlign: 'center' }}>
        {formatMessage(messages.whichLegToRemove)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center' }}>
          {formatMessage(messages.whichLegToRemove)}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', alignItems: 'center', gap: 2, pb: 3, px: 3 }}>
        <Button 
          variant="contained" 
          onClick={handleRemoveBefore}
          fullWidth
          sx={{ maxWidth: 300 }}
        >
          {formatMessage(messages.removeLegNumber, { number: legBeforeNumber })}
        </Button>
        <Button 
          variant="contained" 
          onClick={handleRemoveAfter}
          fullWidth
          sx={{ maxWidth: 300 }}
        >
          {formatMessage(messages.removeLegNumber, { number: legAfterNumber })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteWaypointDialog
